import { removeBlanks } from "../../../../businessLogic/helpers/stringHelpers";

export const extractValuesArray = (results, skipFirstRow = false) => {
  const valuesArray = (results?.data || []).map((row) => Object.values(row));

  if (skipFirstRow) {
    return valuesArray.slice(1);
  }

  return valuesArray;
};

export const getParsedRowByIdOrIndex = (parsedValues, rowId) => {
  const rowById = parsedValues.find(
    (row) => Array.isArray(row) && row[0] === rowId
  );

  return rowById !== undefined ? rowById : parsedValues[rowId];
};

export const getRelatedRowsByAnagraficaKeys = ({ parsedValues, cf, pIva }) =>
  parsedValues.filter(
    (row) =>
      Array.isArray(row) &&
      ((removeBlanks(row[3] || "") === "N" &&
        removeBlanks(row[9] || "") !== "" &&
        removeBlanks(row[9] || "") === pIva) ||
        (removeBlanks(row[3] || "") === "S" &&
          removeBlanks(row[15] || "") !== "" &&
          removeBlanks(row[15] || "") === cf))
  );

export const getRowsByCodice = (parsedValues, codice) =>
  parsedValues.filter((row) => Array.isArray(row) && row[0] === codice);
